import { space, tokPx } from '@sunwebgroup/ui-components'
import { Button, Token, Typography } from '@sunwebgroup/ui-components/uds'

import { styled } from 'styled-components'

import { useIntl } from '@/intl'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { useFilters } from '@/scopes/search/search/domain/hooks'

import {
  BathroomCountTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/BathroomCountTokens'
import {
  BedsInLivingroomTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/BedsInLivingroomTokens'
import {
  HasAvailabilityNextSeasonTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/HasAvailabilityNextSeasonTokens'
import {
  HasAvailabilityTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/HasAvailabilityTokens'
import {
  MetersToSkiLiftTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/MetersToSkiLiftTokens'
import {
  MetersToSlopeTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/MetersToSlopeTokens'
import {
  SkiAreaMinimumAltitudeMetersTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/SkiAreaMinimumAltitudeMetersTokens'
import {
  SkiAreaSlopeKmsTokens,
} from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/SkiAreaSlopeKmsTokens'
import { AccommodationTypeTokens } from './AccomodationTypeTokens'
import { AirlineTokens } from './AirlineTokens'
import { ChildrenFacilitiesTokens } from './ChildrenFacilitiesTokens'
import { CollectionTokens } from './CollectionTokens'
import { CustomerRatingTokens } from './CustomerRatingTokens'
import { DealTokens } from './DealTokens'
import { DistanceToInterestTokens } from './DistanceToInterestTokens'
import { FacilitiesTokens } from './FacilitiesTokens'
import { InternetFacilitiesTokens } from './InternetFacilitiesTokens'
import { MealPlanTokens } from './MealPlanTokens'
import { NumberOfRoomsTokens } from './NumberOfRoomsTokens'
import { PricePerPersonTokens } from './PricePerPersonTokens'
import { StarsTokens } from './StarsTokens'
import { VacationTypeTokens } from './VacationTypeTokens'

const ResetFiltersButton = styled(Button)`
  padding-left: ${space('primitives_space_4')};
  padding-right: ${space('primitives_space_4')};

  &:first-child:last-child {
    display: none;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-right: ${space('primitives_space_4')};
    margin-bottom: ${space('primitives_space_8')};
  }
`

const TokenWrapper = styled(Token)`
    display: flex;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    padding-top: ${tokPx('primitives_space_4')};
    padding-bottom: ${tokPx('primitives_space_4')};
    height: auto;

    ${Typography} {
      flex: 1 1 auto;
      min-width: 0;
      white-space: normal;
      text-align: left;
    }
  `

function SelectedFiltersTokens({ withResetButton }: { withResetButton?: boolean }) {
  const intl = useIntl()
  const { resetOptionalFilters } = useFilters()
  const isAirlineFilterEnabled = useFeatureFlag('BAHAMAS_ENABLE_AIRLINE_FILTER')

  return (
    <Wrapper>
      {isAirlineFilterEnabled && <AirlineTokens />}
      <AccommodationTypeTokens />
      <MealPlanTokens />
      <DealTokens />
      <FacilitiesTokens />
      <StarsTokens />
      <CustomerRatingTokens />
      <ChildrenFacilitiesTokens />
      <InternetFacilitiesTokens />
      <VacationTypeTokens />
      <NumberOfRoomsTokens />
      <DistanceToInterestTokens />
      <CollectionTokens />
      <PricePerPersonTokens />
      <HasAvailabilityTokens />
      <HasAvailabilityNextSeasonTokens />
      <MetersToSlopeTokens />
      <MetersToSkiLiftTokens />
      <SkiAreaMinimumAltitudeMetersTokens />
      <SkiAreaSlopeKmsTokens />
      <BedsInLivingroomTokens />
      <BathroomCountTokens />
      {withResetButton && (
        <ResetFiltersButton variant="transparentNeutral" size="S" onClick={resetOptionalFilters}>
          {intl.formatMessage({
            id: 'search_reset_filters',
          })}
        </ResetFiltersButton>
      )}
    </Wrapper>
  )
}

export { SelectedFiltersTokens, TokenWrapper }
